module.exports = __webpack_public_path__ + "img/comfort-sensor-closeup-vent.4c02f619.jpg";